export const posts = [
  {
    "slug": "january-prices-match-2022-01-03",
    "title": "Match January prices on the page and the listing, January 3, 2022",
    "seoTitle": "January prices (clinic, January 3, 2022)",
    "description": "January prices for a clinic on January 3, 2022. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2022-01-03",
    "cta": "This week, look at the price you are charging now. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A new year price that exists only in the shop, not on the page, is how a quote turns into an argument.",
          "This January 3, 2022 note is for a clinic. The check is January prices: the price you are charging now, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the price you are charging now",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the price you are charging now. In January 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The price you are charging now on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the price you are charging now before you add anything",
        "paragraphs": [
          "A mismatch on January prices is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare the price you are charging now. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Explain December party bookings, December 13, 2021",
        "href": "/blog/party-bookings-2021-12-13"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "booking-calendar-year-2022-01-10",
    "title": "Open the booking calendar on this year, January 10, 2022",
    "seoTitle": "Booking calendar year (restaurant, January 10, 2022)",
    "description": "Booking calendar year for a restaurant on January 10, 2022. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2022-01-10",
    "cta": "This week, look at the year on the booking calendar. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A calendar still sitting on last year sends people to dates that already passed. Click through on a phone before you share the link again.",
          "This January 10, 2022 note is for a restaurant. The check is booking calendar year: the year on the booking calendar, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the year on the booking calendar",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the year on the booking calendar. In January 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The year on the booking calendar on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the year on the booking calendar before you add anything",
        "paragraphs": [
          "A mismatch on booking calendar year is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare the year on the booking calendar. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Match January prices on the page and the listing, January 3, 2022",
        "href": "/blog/january-prices-match-2022-01-03"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "old-season-photos-2022-01-17",
    "title": "Swap photos that still show last season, January 17, 2022",
    "seoTitle": "Seasonal business photos (law office, January 17, 2022)",
    "description": "Seasonal business photos for a law office on January 17, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-01-17",
    "cta": "This week, look at photos from the season you are in. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Snow on the awning in a July photo is a different problem. In January, a summer patio shot as the cover makes the place look closed.",
          "This January 17, 2022 note is for a law office. The check is seasonal business photos: photos from the season you are in, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at photos from the season you are in",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at photos from the season you are in. In January 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Photos from the season you are in on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix photos from the season you are in before you add anything",
        "paragraphs": [
          "A mismatch on seasonal business photos is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare photos from the season you are in. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Set New Year hours before the week starts, December 27, 2021",
        "href": "/blog/new-year-hours-2022-2021-12-27"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "short-staff-hours-2022-01-24",
    "title": "Publish the shorter hours a small crew can keep, January 24, 2022",
    "seoTitle": "Short-staff hours (retail shop, January 24, 2022)",
    "description": "Short-staff hours for a retail shop on January 24, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-01-24",
    "cta": "This week, look at hours a small crew can actually keep. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Post the hours you can answer the phone for. A full schedule you cannot staff creates a missed call and a bad review.",
          "This January 24, 2022 note is for a retail shop. The check is short-staff hours: hours a small crew can actually keep, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at hours a small crew can actually keep",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at hours a small crew can actually keep. In January 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Hours a small crew can actually keep on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix hours a small crew can actually keep before you add anything",
        "paragraphs": [
          "A mismatch on short-staff hours is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare hours a small crew can actually keep. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Swap photos that still show last season, January 17, 2022",
        "href": "/blog/old-season-photos-2022-01-17"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "january-demand-2022-01-31",
    "title": "Name the job people are asking for this month, January 31, 2022",
    "seoTitle": "January service demand (contractor, January 31, 2022)",
    "description": "January service demand for a contractor on January 31, 2022. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2022-01-31",
    "cta": "This week, look at the job people are asking for now. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The homepage should lead with the work this month actually brings in, not a service you only did in summer.",
          "This January 31, 2022 note is for a contractor. The check is January service demand: the job people are asking for now, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the job people are asking for now",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the job people are asking for now. In January 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The job people are asking for now on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the job people are asking for now before you add anything",
        "paragraphs": [
          "A mismatch on January service demand is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare the job people are asking for now. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Open the booking calendar on this year, January 10, 2022",
        "href": "/blog/booking-calendar-year-2022-01-10"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "february-menu-2022-02-07",
    "title": "Check the February menu or service list, February 7, 2022",
    "seoTitle": "February service list (salon, February 7, 2022)",
    "description": "February service list for a salon on February 7, 2022. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2022-02-07",
    "cta": "This week, look at the list of what you offer now. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Winter items you no longer sell should come off the page. What you do have should be readable on a phone, not locked in a PDF.",
          "This February 7, 2022 note is for a salon. The check is February service list: the list of what you offer now, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the list of what you offer now",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the list of what you offer now. In February 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The list of what you offer now on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the list of what you offer now before you add anything",
        "paragraphs": [
          "A mismatch on February service list is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare the list of what you offer now. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of February 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Start the fall list when the kitchen or shop does, August 30, 2021",
        "href": "/blog/menu-into-fall-2021-08-30"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "valentine-hours-2022-2022-02-14",
    "title": "Put Valentine's week hours and the offer in one place, February 14, 2022",
    "seoTitle": "Valentine's week hours (clinic, February 14, 2022)",
    "description": "Valentine's week hours for a clinic on February 14, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-02-14",
    "cta": "This week, look at Valentine's week. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If 2022 includes a Valentine offer or a fuller book, say the hours and the last day of the offer. Leave the business name alone.",
          "This February 14, 2022 note is for a clinic. The check is Valentine's week hours: Valentine's week, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Valentine's week",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Valentine's week. In February 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Valentine's week on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Valentine's week before you add anything",
        "paragraphs": [
          "A mismatch on Valentine's week hours is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare Valentine's week. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of February 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish the shorter hours a small crew can keep, January 24, 2022",
        "href": "/blog/short-staff-hours-2022-01-24"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "pair-booking-2022-02-21",
    "title": "Say whether people can book together, February 21, 2022",
    "seoTitle": "Booking for two (restaurant, February 21, 2022)",
    "description": "Booking for two for a restaurant on February 21, 2022. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2022-02-21",
    "cta": "This week, look at whether two people can book together. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If couples or pairs ask every February, the page should say how that works. If you do not do it, do not imply that you do.",
          "This February 21, 2022 note is for a restaurant. The check is booking for two: whether two people can book together, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at whether two people can book together",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at whether two people can book together. In February 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Whether two people can book together on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix whether two people can book together before you add anything",
        "paragraphs": [
          "A mismatch on booking for two is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare whether two people can book together. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of February 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Name the job people are asking for this month, January 31, 2022",
        "href": "/blog/january-demand-2022-01-31"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "dark-afternoon-photos-2022-02-28",
    "title": "Use photos that match a short winter day, February 28, 2022",
    "seoTitle": "Winter business photos (law office, February 28, 2022)",
    "description": "Winter business photos for a law office on February 28, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-02-28",
    "cta": "This week, look at photos that match the light this month. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A cover photo of a bright patio is a different season. Show the room, the chair, or the truck as they look now.",
          "This February 28, 2022 note is for a law office. The check is winter business photos: photos that match the light this month, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at photos that match the light this month",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at photos that match the light this month. In February 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Photos that match the light this month on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix photos that match the light this month before you add anything",
        "paragraphs": [
          "A mismatch on winter business photos is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare photos that match the light this month. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of February 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Put Valentine's week hours and the offer in one place, February 14, 2022",
        "href": "/blog/valentine-hours-2022-2022-02-14"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "outdoor-season-prep-2022-03-07",
    "title": "Say when outdoor work or seating starts, March 7, 2022",
    "seoTitle": "Outdoor season hours (retail shop, March 7, 2022)",
    "description": "Outdoor season hours for a retail shop on March 7, 2022. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2022-03-07",
    "cta": "This week, look at when outdoor service starts. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If the patio, the lot, or the exterior jobs start this month, the page should say when. If they do not, do not promise them.",
          "This March 7, 2022 note is for a retail shop. The check is outdoor season hours: when outdoor service starts, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at when outdoor service starts",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at when outdoor service starts. In March 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "When outdoor service starts on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix when outdoor service starts before you add anything",
        "paragraphs": [
          "A mismatch on outdoor season hours is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare when outdoor service starts. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Say whether people can book together, February 21, 2022",
        "href": "/blog/pair-booking-2022-02-21"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "know-which-analytics-2022-2022-03-14",
    "title": "Know which analytics number you trust, March 14, 2022",
    "seoTitle": "Which analytics report to trust (contractor, March 14, 2022)",
    "description": "Which analytics report to trust for a contractor on March 14, 2022. What to check so the website and Google listing agree.",
    "section": "Site speed",
    "date": "2022-03-14",
    "cta": "This week, look at the visit number you look at. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "By March 2022 the newer analytics property was the one Google wanted people to learn. If you look at a report, know which one is still the plan. The page itself still has to show the phone number.",
          "This March 14, 2022 note is for a contractor. The check is which analytics report to trust: the visit number you look at, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the visit number you look at",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the visit number you look at. In March 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The visit number you look at on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the visit number you look at before you add anything",
        "paragraphs": [
          "A mismatch on which analytics report to trust is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare the visit number you look at. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Watch the page experience on a phone, June 21, 2021",
        "href": "/blog/core-web-vitals-arrive-2021-2021-06-21"
      },
      {
        "title": "Core Web Vitals for a Local Service Business",
        "href": "/blog/core-web-vitals-for-a-local-service-business"
      }
    ]
  },
  {
    "slug": "weather-change-demand-2022-03-21",
    "title": "Name what people book when the weather turns, March 21, 2022",
    "seoTitle": "Seasonal demand (salon, March 21, 2022)",
    "description": "Seasonal demand for a salon on March 21, 2022. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2022-03-21",
    "cta": "This week, look at the job the weather is creating. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Write the service people are calling about, in their words. A generic list from last year will not match the calls.",
          "This March 21, 2022 note is for a salon. The check is seasonal demand: the job the weather is creating, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the job the weather is creating",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the job the weather is creating. In March 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The job the weather is creating on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the job the weather is creating before you add anything",
        "paragraphs": [
          "A mismatch on seasonal demand is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare the job the weather is creating. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Say when outdoor work or seating starts, March 7, 2022",
        "href": "/blog/outdoor-season-prep-2022-03-07"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "do-not-pause-for-a-redesign-2022-03-28",
    "title": "Keep the phone number up while you edit, March 28, 2022",
    "seoTitle": "Phone number during an edit (clinic, March 28, 2022)",
    "description": "Phone number during an edit for a clinic on March 28, 2022. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2022-03-28",
    "cta": "This week, look at the number while the page is being edited. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "March is a bad time to take the site down for a rebuild. Change the one wrong line and leave the number where it is.",
          "This March 28, 2022 note is for a clinic. The check is phone number during an edit: the number while the page is being edited, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the number while the page is being edited",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the number while the page is being edited. In March 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The number while the page is being edited on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the number while the page is being edited before you add anything",
        "paragraphs": [
          "A mismatch on phone number during an edit is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare the number while the page is being edited. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Name what people book when the weather turns, March 21, 2022",
        "href": "/blog/weather-change-demand-2022-03-21"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "spring-photos-of-work-2022-04-04",
    "title": "Show work you finished this spring, April 4, 2022",
    "seoTitle": "Photos of recent work (restaurant, April 4, 2022)",
    "description": "Photos of recent work for a restaurant on April 4, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-04-04",
    "cta": "This week, look at photos of work from this season. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A gallery of jobs from two years ago is a different business. Add a few photos of what you just completed.",
          "This April 4, 2022 note is for a restaurant. The check is photos of recent work: photos of work from this season, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at photos of work from this season",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at photos of work from this season. In April 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Photos of work from this season on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix photos of work from this season before you add anything",
        "paragraphs": [
          "A mismatch on photos of recent work is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare photos of work from this season. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of April 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Use photos that match a short winter day, February 28, 2022",
        "href": "/blog/dark-afternoon-photos-2022-02-28"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "easter-hours-2022-2022-04-11",
    "title": "Write Easter week hours as special hours, April 11, 2022",
    "seoTitle": "Easter week hours (law office, April 11, 2022)",
    "description": "Easter week hours for a law office on April 11, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-04-11",
    "cta": "This week, look at Easter week hours. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Easter week in 2022 is not a normal week. Mark the day you close, and leave the rest of the weekly schedule as the days you are open.",
          "This April 11, 2022 note is for a law office. The check is Easter week hours: Easter week hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Easter week hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Easter week hours. In April 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Easter week hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Easter week hours before you add anything",
        "paragraphs": [
          "A mismatch on Easter week hours is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare Easter week hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of April 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Show work you finished this spring, April 4, 2022",
        "href": "/blog/spring-photos-of-work-2022-04-04"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "event-bookings-2022-04-18",
    "title": "Explain event or party bookings on their own, April 18, 2022",
    "seoTitle": "Event booking (retail shop, April 18, 2022)",
    "description": "Event booking for a retail shop on April 18, 2022. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2022-04-18",
    "cta": "This week, look at how a party or event is booked. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you take groups, say the headcount and how to reserve. If you do not, say the ordinary visit is what you do.",
          "This April 18, 2022 note is for a retail shop. The check is event booking: how a party or event is booked, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at how a party or event is booked",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at how a party or event is booked. In April 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "How a party or event is booked on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix how a party or event is booked before you add anything",
        "paragraphs": [
          "A mismatch on event booking is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare how a party or event is booked. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of April 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Keep the phone number up while you edit, March 28, 2022",
        "href": "/blog/do-not-pause-for-a-redesign-2022-03-28"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "april-menu-switch-2022-04-25",
    "title": "Switch the menu or service list for the season, April 25, 2022",
    "seoTitle": "Seasonal menu (contractor, April 25, 2022)",
    "description": "Seasonal menu for a contractor on April 25, 2022. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2022-04-25",
    "cta": "This week, look at the current menu or service list. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Items you cannot make this month should come off. What remains should be text a phone can read.",
          "This April 25, 2022 note is for a contractor. The check is seasonal menu: the current menu or service list, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the current menu or service list",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the current menu or service list. In April 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The current menu or service list on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the current menu or service list before you add anything",
        "paragraphs": [
          "A mismatch on seasonal menu is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare the current menu or service list. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of April 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Check the February menu or service list, February 7, 2022",
        "href": "/blog/february-menu-2022-02-07"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "mother-hours-2022-2022-05-02",
    "title": "Say how Mother's Day bookings work this year, May 2, 2022",
    "seoTitle": "Mother's Day bookings (salon, May 2, 2022)",
    "description": "Mother's Day bookings for a salon on May 2, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-05-02",
    "cta": "This week, look at Mother's Day bookings. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The week of Mother's Day in 2022 fills early for a lot of shops. Say whether you are taking reservations, walk-ins, or neither, and the hour you stop.",
          "This May 2, 2022 note is for a salon. The check is Mother's Day bookings: Mother's Day bookings, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Mother's Day bookings",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Mother's Day bookings. In May 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Mother's Day bookings on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Mother's Day bookings before you add anything",
        "paragraphs": [
          "A mismatch on Mother's Day bookings is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare Mother's Day bookings. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Write Easter week hours as special hours, April 11, 2022",
        "href": "/blog/easter-hours-2022-2022-04-11"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "wedding-season-page-2022-05-09",
    "title": "Say how wedding or event season booking works, May 9, 2022",
    "seoTitle": "Event season booking (clinic, May 9, 2022)",
    "description": "Event season booking for a clinic on May 9, 2022. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2022-05-09",
    "cta": "This week, look at how event bookings work. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If this is the month inquiries spike, say the lead time and what you need to hold a date. If it is not your work, do not borrow it.",
          "This May 9, 2022 note is for a clinic. The check is event season booking: how event bookings work, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at how event bookings work",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at how event bookings work. In May 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "How event bookings work on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix how event bookings work before you add anything",
        "paragraphs": [
          "A mismatch on event season booking is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare how event bookings work. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Explain event or party bookings on their own, April 18, 2022",
        "href": "/blog/event-bookings-2022-04-18"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "cooling-season-2022-05-16",
    "title": "Name cooling, shade, or midday changes, May 16, 2022",
    "seoTitle": "Hot-weather schedule (restaurant, May 16, 2022)",
    "description": "Hot-weather schedule for a restaurant on May 16, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-05-16",
    "cta": "This week, look at how heat changes the day. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If crews start earlier or the shop midday is different, publish that. Last winter's hours are the wrong sign.",
          "This May 16, 2022 note is for a restaurant. The check is hot-weather schedule: how heat changes the day, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at how heat changes the day",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at how heat changes the day. In May 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "How heat changes the day on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix how heat changes the day before you add anything",
        "paragraphs": [
          "A mismatch on hot-weather schedule is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare how heat changes the day. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Say how Mother's Day bookings work this year, May 2, 2022",
        "href": "/blog/mother-hours-2022-2022-05-02"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "patio-open-2022-05-23",
    "title": "Say the day outdoor seating or work resumes, May 23, 2022",
    "seoTitle": "Opening day for outdoor service (law office, May 23, 2022)",
    "description": "Opening day for outdoor service for a law office on May 23, 2022. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2022-05-23",
    "cta": "This week, look at the day outdoor service starts. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Pick a date and put it on the listing and the page. 'Soon' is not a day someone can plan around.",
          "This May 23, 2022 note is for a law office. The check is opening day for outdoor service: the day outdoor service starts, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the day outdoor service starts",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the day outdoor service starts. In May 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The day outdoor service starts on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the day outdoor service starts before you add anything",
        "paragraphs": [
          "A mismatch on opening day for outdoor service is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare the day outdoor service starts. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Say how wedding or event season booking works, May 9, 2022",
        "href": "/blog/wedding-season-page-2022-05-09"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "memorial-hours-2022-2022-05-30",
    "title": "Mark Memorial Day on the listing, May 30, 2022",
    "seoTitle": "Memorial Day hours (retail shop, May 30, 2022)",
    "description": "Memorial Day hours for a retail shop on May 30, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-05-30",
    "cta": "This week, look at Memorial Day hours. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Memorial Day 2022 is a Monday. If you are closed, the weekly Monday hours will still look open unless you add a special hour.",
          "This May 30, 2022 note is for a retail shop. The check is Memorial Day hours: Memorial Day hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Memorial Day hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Memorial Day hours. In May 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Memorial Day hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Memorial Day hours before you add anything",
        "paragraphs": [
          "A mismatch on Memorial Day hours is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare Memorial Day hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Name cooling, shade, or midday changes, May 16, 2022",
        "href": "/blog/cooling-season-2022-05-16"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "fathers-day-follow-2022-06-06",
    "title": "Take the mid-June offer down on time, June 6, 2022",
    "seoTitle": "Expired June offer (contractor, June 6, 2022)",
    "description": "Expired June offer for a contractor on June 6, 2022. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2022-06-06",
    "cta": "This week, look at an offer after its end date. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you ran a short June promotion, the day after it ends the page should look normal again.",
          "This June 6, 2022 note is for a contractor. The check is expired June offer: an offer after its end date, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at an offer after its end date",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at an offer after its end date. In June 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "An offer after its end date on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix an offer after its end date before you add anything",
        "paragraphs": [
          "A mismatch on expired June offer is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare an offer after its end date. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Say the day outdoor seating or work resumes, May 23, 2022",
        "href": "/blog/patio-open-2022-05-23"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "father-hours-2022-2022-06-13",
    "title": "Set Father's Day week hours and capacity, June 13, 2022",
    "seoTitle": "Father's Day hours (salon, June 13, 2022)",
    "description": "Father's Day hours for a salon on June 13, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-06-13",
    "cta": "This week, look at Father's Day week. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If Father's Day 2022 changes the book or the menu, put the hours and the limit on the listing. Take it down the next week.",
          "This June 13, 2022 note is for a salon. The check is Father's Day hours: Father's Day week, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Father's Day week",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Father's Day week. In June 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Father's Day week on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Father's Day week before you add anything",
        "paragraphs": [
          "A mismatch on Father's Day hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare Father's Day week. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Mark Memorial Day on the listing, May 30, 2022",
        "href": "/blog/memorial-hours-2022-2022-05-30"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "wedding-peak-2022-06-20",
    "title": "State the lead time at the peak of the season, June 20, 2022",
    "seoTitle": "Peak season lead time (clinic, June 20, 2022)",
    "description": "Peak season lead time for a clinic on June 20, 2022. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2022-06-20",
    "cta": "This week, look at how far ahead people must book. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Peak month is when the page needs the real wait. Update it when the calendar fills, not in the fall.",
          "This June 20, 2022 note is for a clinic. The check is peak season lead time: how far ahead people must book, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at how far ahead people must book",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at how far ahead people must book. In June 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "How far ahead people must book on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix how far ahead people must book before you add anything",
        "paragraphs": [
          "A mismatch on peak season lead time is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare how far ahead people must book. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Take the mid-June offer down on time, June 6, 2022",
        "href": "/blog/fathers-day-follow-2022-06-06"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "midday-heat-break-2022-06-27",
    "title": "Publish a midday break if the heat stops work, June 27, 2022",
    "seoTitle": "Midday closure (restaurant, June 27, 2022)",
    "description": "Midday closure for a restaurant on June 27, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-06-27",
    "cta": "This week, look at a midday break. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you stop for the hottest hours, write that break on the listing. Customers read a continuous block as 'come whenever.'",
          "This June 27, 2022 note is for a restaurant. The check is midday closure: a midday break, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a midday break",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a midday break. In June 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A midday break on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a midday break before you add anything",
        "paragraphs": [
          "A mismatch on midday closure is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare a midday break. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Set Father's Day week hours and capacity, June 13, 2022",
        "href": "/blog/father-hours-2022-2022-06-13"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "july4-hours-2022-2022-07-04",
    "title": "Write July 4 hours before the weekend, July 4, 2022",
    "seoTitle": "July 4 hours (law office, July 4, 2022)",
    "description": "July 4 hours for a law office on July 4, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-07-04",
    "cta": "This week, look at July 4 hours. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Set July 4, 2022 as a special hour if you close or shorten the day. Do it before the weekend, not after the first wrong visit.",
          "This July 4, 2022 note is for a law office. The check is July 4 hours: July 4 hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at July 4 hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at July 4 hours. In July 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "July 4 hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix July 4 hours before you add anything",
        "paragraphs": [
          "A mismatch on July 4 hours is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare July 4 hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish a midday break if the heat stops work, June 27, 2022",
        "href": "/blog/midday-heat-break-2022-06-27"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "july-photo-2022-07-11",
    "title": "Add a July photo of a finished job, July 11, 2022",
    "seoTitle": "July work photo (retail shop, July 11, 2022)",
    "description": "July work photo for a retail shop on July 11, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-07-11",
    "cta": "This week, look at a photo from this month. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Show a job, a plate, or a service you did in this heat. Stock art of a handshake does not help.",
          "This July 11, 2022 note is for a retail shop. The check is July work photo: a photo from this month, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a photo from this month",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a photo from this month. In July 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A photo from this month on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a photo from this month before you add anything",
        "paragraphs": [
          "A mismatch on July work photo is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare a photo from this month. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Write July 4 hours before the weekend, July 4, 2022",
        "href": "/blog/july4-hours-2022-2022-07-04"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "visitor-note-2022-07-18",
    "title": "Tell visitors how to find you in a busy month, July 18, 2022",
    "seoTitle": "Directions for a first visit (contractor, July 18, 2022)",
    "description": "Directions for a first visit, contractor, July 18, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-07-18",
    "cta": "This week, look at how a first-timer finds the door. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If traffic or a festival changes the approach, say which entrance. The pin alone will put them on the wrong curb.",
          "This July 18, 2022 note is for a contractor. The check is directions for a first visit: how a first-timer finds the door, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at how a first-timer finds the door",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at how a first-timer finds the door. In July 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "How a first-timer finds the door on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix how a first-timer finds the door before you add anything",
        "paragraphs": [
          "A mismatch on directions for a first visit is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare how a first-timer finds the door. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Add a July photo of a finished job, July 11, 2022",
        "href": "/blog/july-photo-2022-07-11"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "one-summer-sale-2022-07-25",
    "title": "Limit the summer sale to one sentence, July 25, 2022",
    "seoTitle": "Summer sale (salon, July 25, 2022)",
    "description": "Summer sale for a salon on July 25, 2022. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2022-07-25",
    "cta": "This week, look at one summer offer. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Say the offer and the end date under the phone number. A full-screen takeover is how you hide the call.",
          "This July 25, 2022 note is for a salon. The check is summer sale: one summer offer, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at one summer offer",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at one summer offer. In July 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "One summer offer on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix one summer offer before you add anything",
        "paragraphs": [
          "A mismatch on summer sale is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare one summer offer. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "State the lead time at the peak of the season, June 20, 2022",
        "href": "/blog/wedding-peak-2022-06-20"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "still-hot-2022-08-01",
    "title": "Keep the heat note only while it is true, August 1, 2022",
    "seoTitle": "Heat notice (clinic, August 1, 2022)",
    "description": "Heat notice for a clinic on August 1, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-08-01",
    "cta": "This week, look at a heat note that may be stale. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If the midday break ended, remove it. A warning about a problem you no longer have looks careless.",
          "This August 1, 2022 note is for a clinic. The check is heat notice: a heat note that may be stale, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a heat note that may be stale",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a heat note that may be stale. In August 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A heat note that may be stale on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a heat note that may be stale before you add anything",
        "paragraphs": [
          "A mismatch on heat notice is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare a heat note that may be stale. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Tell visitors how to find you in a busy month, July 18, 2022",
        "href": "/blog/visitor-note-2022-07-18"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "august-event-2022-08-08",
    "title": "Post one August event with a time and a door, August 8, 2022",
    "seoTitle": "August event (restaurant, August 8, 2022)",
    "description": "August event for a restaurant on August 8, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-08-08",
    "cta": "This week, look at one event's time and entrance. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Time, date, and which door. An event with none of those is a post people cannot use.",
          "This August 8, 2022 note is for a restaurant. The check is August event: one event's time and entrance, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at one event's time and entrance",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at one event's time and entrance. In August 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "One event's time and entrance on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix one event's time and entrance before you add anything",
        "paragraphs": [
          "A mismatch on August event is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare one event's time and entrance. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Keep the heat note only while it is true, August 1, 2022",
        "href": "/blog/still-hot-2022-08-01"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "school-hours-2022-2022-08-15",
    "title": "Publish back-to-school hours the week they start, August 15, 2022",
    "seoTitle": "Back-to-school hours (law office, August 15, 2022)",
    "description": "Back-to-school hours for a law office on August 15, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-08-15",
    "cta": "This week, look at back-to-school hours. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "School schedules in 2022 change the rush hour. Write the hours you will keep once classes start, on the listing and the page.",
          "This August 15, 2022 note is for a law office. The check is back-to-school hours: back-to-school hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at back-to-school hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at back-to-school hours. In August 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Back-to-school hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix back-to-school hours before you add anything",
        "paragraphs": [
          "A mismatch on back-to-school hours is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare back-to-school hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Post one August event with a time and a door, August 8, 2022",
        "href": "/blog/august-event-2022-08-08"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "write-for-the-caller-2022-2022-08-22",
    "title": "Write the page for the person who will call, August 22, 2022",
    "seoTitle": "A page written for the caller (retail shop, August 22, 2022)",
    "description": "A page written for the caller for a retail shop on August 22, 2022. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2022-08-22",
    "cta": "This week, look at whether the page answers a real question. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Late summer 2022 rewarded pages that helped someone, not pages stuffed with a phrase. Say what the visit includes, what it costs to start, and how to reach you.",
          "This August 22, 2022 note is for a retail shop. The check is a page written for the caller: whether the page answers a real question, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at whether the page answers a real question",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at whether the page answers a real question. In August 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Whether the page answers a real question on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix whether the page answers a real question before you add anything",
        "paragraphs": [
          "A mismatch on a page written for the caller is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare whether the page answers a real question. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Limit the summer sale to one sentence, July 25, 2022",
        "href": "/blog/one-summer-sale-2022-07-25"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "staff-returning-2022-08-29",
    "title": "Update the page if the person customers ask for is back, August 29, 2022",
    "seoTitle": "Who is working (contractor, August 29, 2022)",
    "description": "Who is working for a contractor on August 29, 2022. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2022-08-29",
    "cta": "This week, look at who customers can book. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If people book a person, the page should name who is available. A name that is still on vacation will be requested anyway.",
          "This August 29, 2022 note is for a contractor. The check is who is working: who customers can book, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at who customers can book",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at who customers can book. In August 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Who customers can book on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix who customers can book before you add anything",
        "paragraphs": [
          "A mismatch on who is working is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare who customers can book. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Write the page for the person who will call, August 22, 2022",
        "href": "/blog/write-for-the-caller-2022-2022-08-22"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "labor-hours-2022-2022-09-05",
    "title": "Mark Labor Day closed if the door will be locked, September 5, 2022",
    "seoTitle": "Labor Day hours (salon, September 5, 2022)",
    "description": "Labor Day hours for a salon on September 5, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-09-05",
    "cta": "This week, look at Labor Day hours. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Labor Day 2022 is a Monday. Add the special hour. A description that mentions the holiday is not a substitute.",
          "This September 5, 2022 note is for a salon. The check is Labor Day hours: Labor Day hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Labor Day hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Labor Day hours. In September 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Labor Day hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Labor Day hours before you add anything",
        "paragraphs": [
          "A mismatch on Labor Day hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare Labor Day hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish back-to-school hours the week they start, August 15, 2022",
        "href": "/blog/school-hours-2022-2022-08-15"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "september-offer-2022-09-12",
    "title": "Run one September offer under the number, September 12, 2022",
    "seoTitle": "September offer (clinic, September 12, 2022)",
    "description": "September offer for a clinic on September 12, 2022. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2022-09-12",
    "cta": "This week, look at one September offer. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "One line, one end date, under the phone number. Then stop adding strips to the header.",
          "This September 12, 2022 note is for a clinic. The check is September offer: one September offer, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at one September offer",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at one September offer. In September 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "One September offer on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix one September offer before you add anything",
        "paragraphs": [
          "A mismatch on September offer is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare one September offer. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Update the page if the person customers ask for is back, August 29, 2022",
        "href": "/blog/staff-returning-2022-08-29"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "school-traffic-entrance-2022-09-19",
    "title": "Tell people which entrance to use in school traffic, September 19, 2022",
    "seoTitle": "Entrance during school traffic (restaurant, September 19, 2022)",
    "description": "Entrance during school traffic for a restaurant on September 19, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-09-19",
    "cta": "This week, look at the entrance during a busy drop-off. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If the usual curb is blocked at eight and three, say the door that works. Update the pin if the door changed.",
          "This September 19, 2022 note is for a restaurant. The check is entrance during school traffic: the entrance during a busy drop-off, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the entrance during a busy drop-off",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the entrance during a busy drop-off. In September 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The entrance during a busy drop-off on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the entrance during a busy drop-off before you add anything",
        "paragraphs": [
          "A mismatch on entrance during school traffic is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare the entrance during a busy drop-off. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Mark Labor Day closed if the door will be locked, September 5, 2022",
        "href": "/blog/labor-hours-2022-2022-09-05"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "weekend-rush-2022-09-26",
    "title": "Publish weekend hours that match the fall rush, September 26, 2022",
    "seoTitle": "Weekend hours (law office, September 26, 2022)",
    "description": "Weekend hours for a law office on September 26, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-09-26",
    "cta": "This week, look at weekend hours this month. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A weekend that now runs later, or stops taking walk-ins, has to be written that way.",
          "This September 26, 2022 note is for a law office. The check is weekend hours: weekend hours this month, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at weekend hours this month",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at weekend hours this month. In September 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Weekend hours this month on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix weekend hours this month before you add anything",
        "paragraphs": [
          "A mismatch on weekend hours is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare weekend hours this month. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Tell people which entrance to use in school traffic, September 19, 2022",
        "href": "/blog/school-traffic-entrance-2022-09-19"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "october-monday-holiday-2022-10-03",
    "title": "Set hours for the October Monday holiday, October 3, 2022",
    "seoTitle": "October Monday holiday hours (retail shop, October 3, 2022)",
    "description": "October Monday holiday hours for a retail shop on October 3, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-10-03",
    "cta": "This week, look at the October Monday holiday. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If that Monday is closed, mark it. The weekly Monday hours will still say open.",
          "This October 3, 2022 note is for a retail shop. The check is October Monday holiday hours: the October Monday holiday, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the October Monday holiday",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the October Monday holiday. In October 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The October Monday holiday on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the October Monday holiday before you add anything",
        "paragraphs": [
          "A mismatch on October Monday holiday hours is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare the October Monday holiday. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish weekend hours that match the fall rush, September 26, 2022",
        "href": "/blog/weekend-rush-2022-09-26"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "seasonal-display-2022-10-10",
    "title": "Match the listing photo to the display people will see, October 10, 2022",
    "seoTitle": "Seasonal display photo (contractor, October 10, 2022)",
    "description": "Seasonal display photo for a contractor on October 10, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-10-10",
    "cta": "This week, look at the display in the window. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "People use the photo to decide they are in the right place. A bare window in the photo and a full one on the street is a small confusion that adds up.",
          "This October 10, 2022 note is for a contractor. The check is seasonal display photo: the display in the window, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the display in the window",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the display in the window. In October 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The display in the window on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the display in the window before you add anything",
        "paragraphs": [
          "A mismatch on seasonal display photo is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare the display in the window. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Set hours for the October Monday holiday, October 3, 2022",
        "href": "/blog/october-monday-holiday-2022-10-03"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "fall-maintenance-2022-10-17",
    "title": "Describe the fall maintenance visit in a few lines, October 17, 2022",
    "seoTitle": "Fall maintenance visit (salon, October 17, 2022)",
    "description": "Fall maintenance visit for a salon on October 17, 2022. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2022-10-17",
    "cta": "This week, look at what a fall visit includes. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "What you check, how you charge, and how soon you can come. Three lines beat a slogan.",
          "This October 17, 2022 note is for a salon. The check is fall maintenance visit: what a fall visit includes, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at what a fall visit includes",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at what a fall visit includes. In October 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "What a fall visit includes on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix what a fall visit includes before you add anything",
        "paragraphs": [
          "A mismatch on fall maintenance visit is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare what a fall visit includes. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Run one September offer under the number, September 12, 2022",
        "href": "/blog/september-offer-2022-09-12"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "earlier-october-close-2022-10-24",
    "title": "Write the earlier close if the day ends sooner, October 24, 2022",
    "seoTitle": "Earlier closing time (clinic, October 24, 2022)",
    "description": "Earlier closing time for a clinic on October 24, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-10-24",
    "cta": "This week, look at the new closing time. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you lock the door at five now, the listing cannot keep saying seven.",
          "This October 24, 2022 note is for a clinic. The check is earlier closing time: the new closing time, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the new closing time",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the new closing time. In October 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The new closing time on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the new closing time before you add anything",
        "paragraphs": [
          "A mismatch on earlier closing time is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare the new closing time. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Match the listing photo to the display people will see, October 10, 2022",
        "href": "/blog/seasonal-display-2022-10-10"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "halloween-hours-2022-2022-10-31",
    "title": "Publish Halloween day hours, October 31, 2022",
    "seoTitle": "Halloween hours (restaurant, October 31, 2022)",
    "description": "Halloween hours for a restaurant on October 31, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-10-31",
    "cta": "This week, look at Halloween day hours. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Halloween 2022 often means an earlier close or a later door. Write the day itself, not a vague seasonal note.",
          "This October 31, 2022 note is for a restaurant. The check is Halloween hours: Halloween day hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Halloween day hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Halloween day hours. In October 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Halloween day hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Halloween day hours before you add anything",
        "paragraphs": [
          "A mismatch on Halloween hours is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare Halloween day hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Write the earlier close if the day ends sooner, October 24, 2022",
        "href": "/blog/earlier-october-close-2022-10-24"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "veterans-hours-2022-2022-11-07",
    "title": "Set Veterans Day hours if you close, November 7, 2022",
    "seoTitle": "Veterans Day hours (law office, November 7, 2022)",
    "description": "Veterans Day hours for a law office on November 7, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-11-07",
    "cta": "This week, look at Veterans Day hours. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you close or shorten Veterans Day 2022, write that day on the listing. The weekly schedule does not know the holiday.",
          "This November 7, 2022 note is for a law office. The check is Veterans Day hours: Veterans Day hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Veterans Day hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Veterans Day hours. In November 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Veterans Day hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Veterans Day hours before you add anything",
        "paragraphs": [
          "A mismatch on Veterans Day hours is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare Veterans Day hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish Halloween day hours, October 31, 2022",
        "href": "/blog/halloween-hours-2022-2022-10-31"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "november-photos-2022-11-14",
    "title": "Show the shop dressed for this month, if it is, November 14, 2022",
    "seoTitle": "November photos (retail shop, November 14, 2022)",
    "description": "November photos for a retail shop on November 14, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-11-14",
    "cta": "This week, look at a current photo. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you decorate, photograph that. If you do not, do not use a stock table setting.",
          "This November 14, 2022 note is for a retail shop. The check is November photos: a current photo, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a current photo",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a current photo. In November 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A current photo on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a current photo before you add anything",
        "paragraphs": [
          "A mismatch on November photos is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare a current photo. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Set Veterans Day hours if you close, November 7, 2022",
        "href": "/blog/veterans-hours-2022-2022-11-07"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "thanksgiving-hours-2022-2022-11-21",
    "title": "Write Thanksgiving week hours before Monday, November 21, 2022",
    "seoTitle": "Thanksgiving hours (contractor, November 21, 2022)",
    "description": "Thanksgiving hours for a contractor on November 21, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-11-21",
    "cta": "This week, look at Thanksgiving week hours. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Put Thanksgiving 2022 on special hours in Google Business Profile, and mirror them on the contact page.",
          "This November 21, 2022 note is for a contractor. The check is Thanksgiving hours: Thanksgiving week hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Thanksgiving week hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Thanksgiving week hours. In November 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Thanksgiving week hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Thanksgiving week hours before you add anything",
        "paragraphs": [
          "A mismatch on Thanksgiving hours is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare Thanksgiving week hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Show the shop dressed for this month, if it is, November 14, 2022",
        "href": "/blog/november-photos-2022-11-14"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "drafts-need-your-facts-2022-2022-11-28",
    "title": "A writing tool still needs your facts, November 28, 2022",
    "seoTitle": "Editing a drafted page (salon, November 28, 2022)",
    "description": "Editing a drafted page for a salon on November 28, 2022. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2022-11-28",
    "cta": "This week, look at facts you have to supply yourself. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "In November 2022 some owners started pasting drafts from a new writing tool. It does not know your hours, your cities, or your prices. Read every sentence as the person who answers the phone.",
          "This November 28, 2022 note is for a salon. The check is editing a drafted page: facts you have to supply yourself, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at facts you have to supply yourself",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at facts you have to supply yourself. In November 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Facts you have to supply yourself on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix facts you have to supply yourself before you add anything",
        "paragraphs": [
          "A mismatch on editing a drafted page is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare facts you have to supply yourself. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "december-photos-2022-12-05",
    "title": "Use a December photo of your real space, December 5, 2022",
    "seoTitle": "December photo (clinic, December 5, 2022)",
    "description": "December photo for a clinic on December 5, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-12-05",
    "cta": "This week, look at a photo from this month. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Lights are fine if they are yours. A catalog photo of a table you do not have will not match the visit.",
          "This December 5, 2022 note is for a clinic. The check is December photo: a photo from this month, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a photo from this month",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a photo from this month. In December 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A photo from this month on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a photo from this month before you add anything",
        "paragraphs": [
          "A mismatch on December photo is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare a photo from this month. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Write Thanksgiving week hours before Monday, November 21, 2022",
        "href": "/blog/thanksgiving-hours-2022-2022-11-21"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "extended-hours-2022-12-12",
    "title": "Add extended hours only on the days you stay, December 12, 2022",
    "seoTitle": "Extended December hours (restaurant, December 12, 2022)",
    "description": "Extended December hours for a restaurant on December 12, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-12-12",
    "cta": "This week, look at days you stay open later. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Change those days. Do not stretch the whole month to match one Saturday.",
          "This December 12, 2022 note is for a restaurant. The check is extended December hours: days you stay open later, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at days you stay open later",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at days you stay open later. In December 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Days you stay open later on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix days you stay open later before you add anything",
        "paragraphs": [
          "A mismatch on extended December hours is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare days you stay open later. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Use a December photo of your real space, December 5, 2022",
        "href": "/blog/december-photos-2022-12-05"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "christmas-hours-2022-2022-12-19",
    "title": "Separate Christmas Eve, Christmas Day, and the days after, December 19, 2022",
    "seoTitle": "Christmas hours (law office, December 19, 2022)",
    "description": "Christmas hours for a law office on December 19, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-12-19",
    "cta": "This week, look at Christmas week hours. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Write Christmas Eve, Christmas Day, and the day you reopen for 2022. One line that says \"closed for the holidays\" is not a schedule.",
          "This December 19, 2022 note is for a law office. The check is Christmas hours: Christmas week hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Christmas week hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Christmas week hours. In December 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Christmas week hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Christmas week hours before you add anything",
        "paragraphs": [
          "A mismatch on Christmas hours is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare Christmas week hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Add extended hours only on the days you stay, December 12, 2022",
        "href": "/blog/extended-hours-2022-12-12"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "new-year-hours-2023-2022-12-26",
    "title": "Set New Year hours before the week starts, December 26, 2022",
    "seoTitle": "New Year hours (retail shop, December 26, 2022)",
    "description": "New Year hours for a retail shop on December 26, 2022. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2022-12-26",
    "cta": "This week, look at New Year hours. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Write New Year hours on the profile and the contact page for 2023. Check them on a phone, because that is where people look the night before.",
          "This December 26, 2022 note is for a retail shop. The check is New Year hours: New Year hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at New Year hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at New Year hours. In December 2022 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "New Year hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix New Year hours before you add anything",
        "paragraphs": [
          "A mismatch on New Year hours is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare New Year hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2022 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Separate Christmas Eve, Christmas Day, and the days after, December 19, 2022",
        "href": "/blog/christmas-hours-2022-2022-12-19"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  }
];
